import { Button, styled } from '@mui/material';

export const AuditButton = styled(Button)(({ theme }) => ({
  padding: '4px 12px',
  fontSize: 12,
  borderColor: theme.palette.grey[600],
  color: theme.palette.black.main,
}));
